import loadable from '@loadable/component';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import RouteChangeCanceler from './RouteChangeCanceler';
import UpdateExam from 'components/exam/modal/UpdateExam';
import ExamScreen from 'components/exam/ExamScreen';
import NewUpdateExam from 'components/exam/modal/NewUpdateExam';
const ExamPage = loadable(() => import('components/exam/ExamPage'), { fallback: <LoadingIndicator /> });
const AddExam = loadable(() => import('components/exam/modal/AddExam'), { fallback: <LoadingIndicator /> });
const ResultTable = loadable(() => import('components/result/ResultTable'), { fallback: <LoadingIndicator /> });
const ViewResult = loadable(() => import('components/result/sub-screens/ViewResult'), { fallback: <LoadingIndicator /> });

const ExamRoute: React.FC = () => {
    return (
        <div>
             
            {/* <LayoutPage> */}
            <Routes>
                <Route path="/exam/*" element={<ExamPage />} />
                <Route path="/exam/add-exam" element={<NewUpdateExam/>} />
                <Route path="/result" element={<ResultTable />} />
                <Route path="/result/view-result" element={<ViewResult />} />
                <Route path='/exam-page' element={<ExamScreen/>}/>
            </Routes>
            {/* </LayoutPage> */}
        </div>
    )
}

export default ExamRoute;